import styled from 'styled-components';

export const Container = styled.section`
  width: 100%;
  height:100%;
`;
export const BorderRight = styled.div`
  border-right: 1px solid ${(props) => props.theme.colors.surveysManagerTableBorderColor};  
  top: 50%;
  bottom: 0;
`;
export const SearchPanel = styled.div`
  position: sticky;
  z-index:99999;
  top: -21px;
  bottom: 0;
  height: 40px;
  padding-top: 1px;
  margin-top: -29px;
  width: 100%;
  background-color: ${(props) => props.theme.colors.modalBackgroundColor};
  input{
    background-color: ${(props) => props.theme.colors.modalInputSearchBackgroundColor};
  }
`;

export const TablePanel = styled.div`

`;

export const TableFooter = styled.div`  
  display:flex;
  justify-content: center;
  margin-top: 15px;
`;
export const TablePaging = styled.div`
  margin-right: 7%;

`;
export const TableInputPaging = styled.div`
`;
export const TableContent = styled.div`

  table {
    width: 100%;
    border-collapse: collapse;
    margin-top:24px;
  }

  thead {

    tr {
      font-size: 14px;
      line-height: 16px;
      color: ${(props) => props.theme.colors.surveysManagerTextColor};
      text-transform: uppercase;
      text-align: left;
      border-bottom:1px solid ${(props) => props.theme.colors.surveysManagerTableBorderColor};
      height: 60px;
      th {
        padding: 16px 10px;
      }
    }
  }

  tbody {
    tr {
      font-size: 1.2rem;
      border-bottom:1px solid ${(props) => props.theme.colors.surveysManagerTableBorderColor};
      height: 90px;
      font-size: 12px;
      line-height: 14px;
      td {
        color: ${(props) => props.theme.colors.surveysManagerTextColor};
        padding: 8px 10px;
      }

      &.inprogress td {
        color: #ccc;
      }

      .titulo {
        width: 300px;
      }

      .status {
        font-size: 14px;
        line-height: 16px;
        text-transform: uppercase;
        cursor: pointer;
        padding-right:100px;
        &.active {
          color: #11ada0;
        }

        &.inactive {
          color: #F08282;
        }

        &.active::before,
        &.inactive::before {
          width: 10px;
          height: 10px;
          border-radius: 50%;
          display: inline-block;
          content: '';
          margin-right: 10px;
        }

        &.active::before {
          background-color: #11ada0;
        }

        &.active {
          color: #11ada0;
        }

        &.inactive {
          color: #f08282;
        }
        
        .inactive {
          color: #f08282;
        }

        &.inactive::before {
          background-color: #f08282;
        }

        .popup-selector{
          display: inline-block;
        }
      }
    }
  }
`;
